import { useRef, useState, useCallback } from 'react';

export const useDragToScroll = () => {
  const ref = useRef(null); // This will hold the reference to our scrolling element

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // Called when the user presses the mouse button down
  const onMouseDown = useCallback((e) => {
    if (!ref.current) return;
    setIsDragging(true);
    // Record the starting X position of the mouse and the initial scroll position
    setStartX(e.pageX - ref.current.offsetLeft);
    setScrollLeft(ref.current.scrollLeft);
    // Add a class to the body to change the cursor and prevent text selection
    document.body.classList.add('grabbing');
  }, []);

  // Called when the user releases the mouse button
  const onMouseUpOrLeave = useCallback(() => {
    if (!ref.current) return;
    setIsDragging(false);
    // Remove the global class
    document.body.classList.remove('grabbing');
  }, []);

  // Called when the user moves the mouse
  const onMouseMove = useCallback((e) => {
    if (!isDragging || !ref.current) return;
    e.preventDefault(); // Prevent default browser behavior (like dragging an image)
    
    // Calculate the distance the mouse has moved from the start
    const x = e.pageX - ref.current.offsetLeft;
    const walk = (x - startX) * 2; // The multiplier "2" makes the scroll feel faster and more responsive
    
    // Update the element's scroll position
    ref.current.scrollLeft = scrollLeft - walk;
  }, [isDragging, startX, scrollLeft]);

  // Return the ref and the event handlers to be attached to the component
  return {
    ref,
    onMouseDown,
    onMouseUp: onMouseUpOrLeave,
    onMouseLeave: onMouseUpOrLeave,
    onMouseMove,
  };
};